import type { Lucid } from '../../types/types';
import getLanguageData from '../language/getLanguageData';

/** Checks if the languageKey is the language code. */
const isLanguageCode = (languageKey: string): languageKey is Lucid.I18n.LanguagesCode =>
  !!getLanguageData(languageKey, 'code');

export default isLanguageCode;
